import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CoboAccountData } from '../_models/cobo/coboAccountData';

@Injectable()
export class CoboService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCoboAccountData(): Observable<CoboAccountData> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/cobo/getCoboAccountData')
      .pipe(map((response) => response));
  }

  storeCoboCredentials(coboAccountData: CoboAccountData) {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/cobo/storeCoboCredentials', coboAccountData)
      .pipe(map((response) => response));
  }
}
